export const categories = [
  {
    name: '网红反差',
    slug: 'wanghong-fancha',
    description: '揭示网红台前幕后的真实反差，曝光不为人知的另一面',
    coverImage: 'https://readdy.ai/api/search-image?query=Dramatic%20split%20screen%20concept%20with%20contrasting%20light%20and%20shadow%20representing%20dual%20personalities%2C%20artistic%20abstract%20composition%20with%20half%20face%20illuminated%20and%20half%20in%20darkness%2C%20editorial%20photography%20with%20moody%20cinematic%20atmosphere%20and%20golden%20accent%20lighting&width=1600&height=600&seq=cat-wanghong&orientation=landscape',
    articleCount: 45,
  },
  {
    name: '明星塌房',
    slug: 'mingxing-tafang',
    description: '深度追踪明星塌房全过程，还原事件真相与内幕细节',
    coverImage: 'https://readdy.ai/api/search-image?query=Dramatic%20collapsed%20stage%20structure%20with%20broken%20spotlights%20and%20fallen%20curtains%20in%20dark%20theater%20setting%2C%20symbolic%20representation%20of%20scandal%20and%20downfall%20with%20moody%20atmospheric%20lighting%2C%20editorial%20conceptual%20photography%20with%20deep%20shadows%20and%20dramatic%20composition&width=1600&height=600&seq=cat-mingxing&orientation=landscape',
    articleCount: 62,
  },
  {
    name: '每日大赛',
    slug: 'meiri-dasai',
    description: '每日评选全网最劲爆爆料，精彩不停歇，互动赢大奖',
    coverImage: 'https://readdy.ai/api/search-image?query=Grand%20competition%20arena%20stage%20with%20bright%20spotlights%20and%20dramatic%20red%20carpet%20leading%20to%20winner%20podium%2C%20exciting%20tournament%20atmosphere%20with%20golden%20trophies%20and%20elegant%20dark%20backdrop%2C%20professional%20event%20photography%20with%20high%20energy%20and%20cinematic%20lighting&width=1600&height=600&seq=cat-dasai&orientation=landscape',
    articleCount: 128,
  },
  {
    name: '独家首发',
    slug: 'dujia-shoufa',
    description: '专业团队深度调查，第一手资料独家呈现，拒绝二手传播',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20sealed%20envelope%20with%20wax%20stamp%20on%20dark%20marble%20surface%20under%20dramatic%20spotlight%2C%20exclusive%20secret%20document%20atmosphere%20with%20moody%20lighting%20and%20rich%20shadows%2C%20editorial%20still%20life%20photography%20with%20luxury%20aesthetic%20and%20cinematic%20color%20grading&width=1600&height=600&seq=cat-dujia&orientation=landscape',
    articleCount: 34,
  },
];